const state = {
  tabs: []
}
const mutations = {
  ADD_TAB: (state, tab) => {
    let has = false;
    state.tabs.forEach(item=>{
      if(item.name==tab.name){
        has = true;
      }
    })
    if(!has){
      state.tabs.push(tab)
    }
  },
  DEL_TAB: (state, tab) => {
    let has = false;
    state.tabs.forEach((item,index)=>{
      if(item.name==tab.name){
        has = index;
      }
    })
    if(has!=false){
      state.tabs.splice(has,1);
    }
  },
}

const actions = {
  addTab({ commit }, tab) {
    commit('ADD_TAB', tab)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/tabs.js